/** 为模块页主标题拼接租户配置的品牌前缀(如「丝路」) */
export function applyPageTitlePrefix(prefix: string | undefined, title: string): string {
  const base = title.trim()
  const p = prefix?.trim()
  if (!p || !base) return base
  if (base.startsWith(p)) return base
  return `${p}${base}`
}

/** 「浏览作品广场」类文案 */
export function browsePageTitle(prefix: string | undefined, moduleTitle: string, browseLabel: string): string {
  const titled = applyPageTitlePrefix(prefix, moduleTitle)
  if (browseLabel.includes('{{title}}')) {
    return browseLabel.replace('{{title}}', titled)
  }
  return `${browseLabel}${titled}`
}
